
import { t } from 'i18next'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'
import { syncTranslation } from '../utils/translate';
import { TValueLabel } from '../utils/types';
import { parseQueryArguments } from '@/shared';

// The same values as the server model. "Cancelled" stood here too, but the server
// never knew it and refused to save it; taken out (operator, 14.10.2026) — no
// project on daily, demo or production carried it.
export enum EProjectStatus {
  'Planned' = 'planned',
  'Active' = 'active',
  'Paused' = 'paused',
  'Completed' = 'completed',
  'Archived' = 'archived',
}

export type TProject = {
  _id: string,
  name: string,
  description: string;
  startDate: Date;
  endDate?: Date;
  status: EProjectStatus;
  clients: string[],
  emptyNull: boolean,
  /** Overrides the tenant setting; null means "use the tenant value". */
  taskRetentionMinutes?: number | null,
  createdAt: Date,
  uodatedAt: Date,
  //deleted: Date,
}

/**
 * List of project status as value/label pair
 */
let ProjectStatusKeyValues: TValueLabel[] = []
syncTranslation(() => {
  // translate the status to the current language
  ProjectStatusKeyValues = Object.entries(EProjectStatus).map(([label, value]) => ({
    label: t(label),
    value,
  }))
})
export const projectStatusList = (): TValueLabel[] => {
  return ProjectStatusKeyValues
}

export default class ProjectModel implements ITableListModel<TProject> {
  constructor() {
  }

  public async getProjectByName(projectName: string) {
    return await getData(`/projects/by-name/${projectName}`, null, true)
  }

  public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, count, q = '' }: TableListRequestType) {
    // The lists pass the page size as count; reading limit alone left every
    // one of them at ten rows, with no way to the eleventh.
    let query = parseQueryArguments(`page=${page}&limit=${count ?? limit}`, arguments)
    if (q) query += '&q=' + encodeURI(q)
    if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

    return await getData(`/projects?${query}`)
  }

  public async read(id: string) {
    return await getData(`/projects/${id}`)
  }

  public async create(data: any) {
    return await postData('/projects', data)
  }

  public async update(id: string, data: any) {
    return await patchData(`/projects/${id}`, data)
  }

  public async delete(id: string) {
    return await deleteData(`/projects/${id}`)
  }

  public async count() {
    return await countData(`/projects/count`)
  }

}